import { getLocations, getLocationsROI, getLocationGroup, getLocationsItemByGroupId, deleteLocationsGroupId } from "@/api/locations";

export default {
  async getLocations({ commit }) {
    const response = await getLocations();
    commit("setLocations", response);
    commit("setLocationsFix", response);
  },

  async getLocationsROI({ commit, state }) {
    let params = {
      from_date: state.dateRange.start,
      to_date: state.dateRange.end
    };
    const response = await getLocationsROI(params);
    commit("setLocationsROI", response.results);
  },

  async getLocationsGroups({ commit, state }) {
    let params = ''
    let commitInDate = false
    if (state.dateRange.start){
      commitInDate = true
      params = {
        from_date: state.dateRange.start,
        to_date: state.dateRange.end
      };
      commitInDate = true
    }
    if (commitInDate == false){ // this is for dropdown that dont have date range
      let response = await getLocationGroup();
      commit("setLocationsGroup", response);
    }else {// this is for table list that uses date range
      let response = await getLocationGroup(params);
      commit("setLocationsGroupFromDate", response);
    }
  },

  async getLocationsByGroupId({ commit, state }) {
    let groupId = state.locationGroupId;

    if (groupId == 0) {
      commit("setLocationByGroup", []);
    } else {
      let response = await getLocationsItemByGroupId(groupId);
      commit("setLocationByGroup", response.results);
    }
  },
  async deleteLocationsByGroupId({ state }) {
    let groupId = state.locationGroupId;
    await deleteLocationsGroupId(groupId);
  }
};
